import { CommonModule } from '@angular/common';
import { Component, ElementRef, Inject, ViewChild } from '@angular/core';
import { MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';
import { MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { FirebaseTSAuth } from 'firebasets/firebasetsAuth/firebaseTSAuth';
import { FirebaseTSFirestore } from 'firebasets/firebasetsFirestore/firebaseTSFirestore';
import { ChatWindow } from '../../models/chat.model';
import { Message } from 'src/app/pages/messages/messages.component';
import { UserData } from 'src/app/models/user.model';
import { ChatService } from 'src/app/services/chat.service';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { FormsModule } from '@angular/forms';


@Component({
  selector: 'app-chat-content-bottom-sheet',
  standalone: true,
  imports: [
    CommonModule,
    MatMenuModule,
    MatIconModule,
    MatButtonModule,
    FormsModule
  ],
  templateUrl: './chat-content-bottom-sheet.component.html',
  styleUrls: ['./chat-content-bottom-sheet.component.css']
})


export class ChatContentBottomSheetComponent {

  auth = new FirebaseTSAuth;
  private listeners: { [key: string]: () => void } = {};
  
  firestore = new FirebaseTSFirestore();
  currentUserId: string = "";
  isUserAtBottom: boolean = true; // Indicateur pour savoir si l'utilisateur est en bas dans le chatWindow
  
  
  @ViewChild('messageContainer') messageContainer!: ElementRef;
  @ViewChild('messageInput') commentInputRef!: ElementRef<HTMLTextAreaElement>;

  chatWindow: ChatWindow;

  constructor(
    private bottomSheetRef: MatBottomSheetRef<ChatContentBottomSheetComponent>,
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: { user: UserData },
    private chatService: ChatService,
  ) {
    console.log('Bottom sheet data:', data);
    this.chatWindow = {
      userData: data.user,
      newMessage: '',
      messages: [],
      isUserAtBottom: true,
      isRecording: false,
      audioBlobUrl: null,
      currentMediaRecorder: null,
      selectedAudioFile: null,
      selectedImageFile: null,
      imageBlobUrl: null
    };
  }

  ngOnInit(): void {
    console.log('ChatWindow initialized:', this.chatWindow);
    this.currentUserId = this.auth.getAuth().currentUser.uid;
    this.loadMessages();
  }

  loadMessages(): void {
    if (!this.chatWindow?.userData?.uid) {
      console.error('User data not available');
      return;
    }

    const listenerName = `GetChatMessages_${this.currentUserId}_${this.chatWindow.userData.uid}`;

    // Supprimer le listener existant avant d'en ajouter un nouveau
  this.removeListener(listenerName);

    this.chatService.getMessages2(this.currentUserId, this.chatWindow.userData.uid, listenerName)
      .then(messages => {
        console.log('Messages loaded:', messages);
        this.chatWindow.messages = messages;
        this.scrollToBottom();
      })
      .catch(error => {
        console.error('Error loading messages:', error);
      });
  }

  removeListener(listenerName: string): void {
    if (this.listeners[listenerName]) {
      this.listeners[listenerName]();
      delete this.listeners[listenerName];
    }
  }

  // Exemple de méthode pour faire défiler le conteneur de message
  scrollToBottom(): void {
    if (this.messageContainer) {
      this.messageContainer.nativeElement.scrollTop = this.messageContainer.nativeElement.scrollHeight;
    }
  }

  checkIfScrolledToBottom(chatWindow: any, container: any): void {
    // Vérifier si l'utilisateur est proche du bas
    const isAtBottom = container.scrollHeight - container.scrollTop === container.clientHeight;

    // Mettre à jour l'état de la fenêtre de chat pour savoir si l'utilisateur est en bas ou non
    chatWindow.isUserAtBottom = isAtBottom;
  }

  ngAfterViewChecked() {
    // Boucle pour vérifier le statut de chaque chatWindow
    if (this.chatWindow.isUserAtBottom && this.messageContainer) {
      this.scrollToBottom();
    }
  }

  

  getMessageFormattedDate(timestamp: any): string {
    const messageDate = timestamp ? new Date(timestamp) : new Date();
    const now = new Date();
  
    // Calcul de la différence en millisecondes
    const diffInMs = now.getTime() - messageDate.getTime();
    const diffInHours = diffInMs / (1000 * 60 * 60); // conversion en heures
    const diffInDays = diffInMs / (1000 * 60 * 60 * 24); // conversion en jours
  
    // Si le message date d'aujourd'hui
    if (diffInHours < 24) {
      return messageDate.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit', hour12: false });
    } 
  
    // Si le message date d'hier
    else if (diffInHours >= 24 && diffInHours < 48) {
      return `Hier, ${messageDate.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit', hour12: false })}`;
    }
  
    // Si le message est vieux de plus de 48 heures mais dans la même année
    else if (diffInDays >= 2 && now.getFullYear() === messageDate.getFullYear()) {
      return `${messageDate.toLocaleDateString('fr-FR', { day: 'numeric', month: 'short' })} à ${messageDate.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit', hour12: false })}`;
    }
  
    // Si le message date de plus d'une année
    else {
      return messageDate.toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit', year: '2-digit' }) + ' à ' +
             messageDate.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit', hour12: false });
    }
  
  }

  ngAfterViewInit() {
    if (this.messageContainer && this.messageContainer.nativeElement) {
      const nativeElement = this.messageContainer.nativeElement;
      nativeElement.scrollTop = this.messageContainer.nativeElement.scrollHeight;
    } else {
      console.warn('messageContainer n’est pas défini.');
    }
  }


  // Ouvrir une fenêtre de chat
  openChatWindow(user: UserData): void {
    
    

    
    
    

    const listenerName = `GetChatMessages_${this.auth.getAuth().currentUser.uid}_${user.uid}`;
    

     // Récupérer les messages pour ce chat
  const currentUserId = this.auth.getAuth().currentUser.uid;  // Remplacer par l'ID réel de l'utilisateur connecté
  this.chatService.getMessages2(currentUserId, user.uid, listenerName)
    .then(messages => {
      
     this.chatWindow.messages = messages
      // Stocker les messages dans l'objet utilisateur
    })
    .catch(error => {
      console.error('Erreur lors de la récupération des messages:', error);
    });
  }

  

  




  // Fonction pour fermer le BottomSheet
  closeBottomSheet(): void {
    this.bottomSheetRef.dismiss();
  }

  // Fermer une fenêtre de chat
  closeChatWindow(): void {
    if (this.chatWindow?.userData) {
      const listenerName = `GetChatMessages_${this.auth.getAuth().currentUser.uid}_${this.chatWindow.userData.uid}`;
      this.chatService.closeChatWindow3(this.chatWindow.userData.uid, listenerName);
      this.closeBottomSheet();
    }
  } 

  

  handleKeydown(event: KeyboardEvent , chatWindow: ChatWindow) {
    
    if (event.key === 'Enter') {
      if (event.shiftKey) {
        // Shift + Enter: Nouvelle ligne
        const textarea = event.target as HTMLTextAreaElement;
        const cursorPosition = textarea.selectionStart;
        chatWindow.newMessage = chatWindow.newMessage.substring(0, cursorPosition) + '\n' + chatWindow.newMessage.substring(cursorPosition);
        event.preventDefault(); // Empêche l'action par défaut de l'Enter
      } else {
        // Simple Enter: Envoyer le message
        
        this.sendMessage(chatWindow);
        event.preventDefault(); // Empêche l'action par défaut de l'Enter
      }
    }
  }

  onInputChange() {
    const message = this.commentInputRef.nativeElement.value.trim();
    
  }

  

  handleSend(chatWindow: ChatWindow) {
    if (chatWindow.isRecording) {
      // Si l'enregistrement est actif, on arrête l'enregistrement
      this.stopRecording(chatWindow);
    } else {
      if (chatWindow.selectedAudioFile) {
        // Si un fichier audio est sélectionné, l'envoyer
        this.sendAudio(chatWindow.selectedAudioFile, chatWindow);
      } else if (chatWindow.newMessage && chatWindow.newMessage.trim() !== '') {
        // Si un message est présent, l'envoyer
        this.sendMessage(chatWindow);
      } else {
        // Si aucun message n'est présent, commencer l'enregistrement
        this.startRecording(chatWindow);
      }
    }
  }

  sendAudio(file: File, chatWindow: ChatWindow) {
    // Implémentez votre logique pour envoyer le fichier audio
    console.log('Envoi de l\'audio:', file);
    // Vous pouvez appeler un service pour stocker le fichier audio sur Firestore ou Firebase Storage
    this.chatService.sendAudio(file, chatWindow.userData.uid).then(() => {
      // Réinitialisez l'état après l'envoi
      chatWindow.selectedAudioFile = null;
      chatWindow.audioBlobUrl = null;
    }).catch(error => {
      console.error('Erreur lors de l\'envoi de l\'audio:', error);
    });
  }

  startRecording(chatWindow: ChatWindow) {
    chatWindow.isRecording = true;
    console.log("Enregistrement audio commencé");
  
    navigator.mediaDevices.getUserMedia({ audio: true })
      .then(stream => {
        const mediaRecorder = new MediaRecorder(stream);
        let audioChunks: Blob[] = [];
  
        mediaRecorder.ondataavailable = event => {
          audioChunks.push(event.data);
        };
  
        mediaRecorder.onstop = () => {
          const audioBlob = new Blob(audioChunks, { type: 'audio/wav' });
          chatWindow.audioBlobUrl = URL.createObjectURL(audioBlob);
          chatWindow.selectedAudioFile = new File([audioBlob], 'recorded-audio.wav', { type: 'audio/wav' });
          console.log('Enregistrement audio arrêté, blob créé.');
        };
  
        mediaRecorder.start();
        chatWindow.currentMediaRecorder = mediaRecorder;
      })
      .catch(error => {
        console.error("Erreur lors de l'accès au microphone:", error);
      });
  }

  stopRecording(chatWindow: ChatWindow) {
    if (chatWindow.currentMediaRecorder) {
      chatWindow.currentMediaRecorder.stop();
      console.log("Enregistrement audio arrêté");
    }
    chatWindow.isRecording = false; // Mettez à jour l'état ici
   
    // Si vous n'avez pas besoin de garder `selectedAudioFile`, vous pouvez aussi le réinitialiser ici.
  }

  
  
  selectFile(chatWindow: ChatWindow, type: 'audio' | 'image') {
    const fileInput = document.createElement('input');
    
    fileInput.type = 'file';
    fileInput.accept = type === 'audio' ? 'audio/*' : 'image/*';
    
    fileInput.onchange = (event: any) => {
      const file = event.target.files[0];
      if (file) {
        if (type === 'audio') {
          chatWindow.selectedAudioFile = file;
          chatWindow.audioBlobUrl = URL.createObjectURL(file);
          console.log('Fichier audio sélectionné:', file);
        } else if (type === 'image') {
          chatWindow.selectedImageFile = file;
          chatWindow.imageBlobUrl = URL.createObjectURL(file);
          console.log('Fichier image sélectionné:', file);
        }
      }
    };
    
    fileInput.click();
  }

  sendMessage(chatWindow: ChatWindow) {
   
    const currentUserId = this.auth.getAuth().currentUser.uid;
    
    // Vérifiez si un fichier audio ou image est sélectionné
    if (chatWindow.selectedAudioFile || chatWindow.selectedImageFile) {
      const fileToSend = chatWindow.selectedAudioFile || chatWindow.selectedImageFile;
  
      // Si un fichier est sélectionné, utilisez sendFile
      this.chatService.sendFile(currentUserId, chatWindow.userData.uid, fileToSend).then(() => {
        this.removeFile(chatWindow); // Réinitialisez le fichier après l'envoi
        this.scrollToBottom();
        chatWindow.isUserAtBottom = true;
      }).catch(error => {
        console.error("Erreur lors de l'envoi du fichier :", error);
      });
    } else if (chatWindow.newMessage && chatWindow.newMessage.trim() !== '') {
      
      // Si aucun fichier n'est sélectionné, utilisez sendMessage
      this.chatService.sendMessage(currentUserId, chatWindow.userData.uid, chatWindow.newMessage.trim()).then(() => {
        chatWindow.newMessage = '';
        this.scrollToBottom();
        chatWindow.isUserAtBottom = true;
      }).catch(error => {
        console.error("Erreur lors de l'envoi du message :", error);
      });
    }
  }

  removeFile(chatWindow: ChatWindow) {
    chatWindow.selectedAudioFile = null;
    chatWindow.selectedImageFile = null;
    chatWindow.audioBlobUrl = null;
    chatWindow.imageBlobUrl = null;
    console.log('Fichier sélectionné réinitialisé');
  }

  /*sendMessage(chatWindow: ChatWindow){  
    const message = this.commentInputRef.nativeElement.value.trim();
    
    
    const currentUserId = this.auth.getAuth().currentUser.uid;  // Remplacez par l'ID réel de l'utilisateur connecté
    //const chatId = this.chatService.getChatId(currentUserId, chatWindow.userData.uid);

    if (message && message !== '') {
      

    this.chatService.sendMessage(currentUserId,  chatWindow.userData.uid, message).then(() => {
      // Réinitialiser la valeur de newMessage après envoi
      //newMessage = '';
      //this.userData.newMessage = '';
     
      this.commentInputRef.nativeElement.value = '';

      // Scroll automatique vers le bas après l'envoi d'un message

      // Scroll automatique vers le bas après l'envoi d'un message
    
    this.scrollToBottom();
    this.chatWindow.isUserAtBottom = true;
   
      
    })
    .catch(error => {
      console.error('Erreur lors de l\'envoi du message:', error);
    });;
    }
  } */
  
}
